var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhXOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04867 3L9.77043 12.928L2 21H3.74895L10.5521 13.9327L16.0487 21H22L13.8436 10.5136L21.0764 3H19.3274L13.0623 9.50863L8 3H2.04867ZM4.62057 4.23866H7.35459L19.4278 19.7613H16.6937L4.62057 4.23866Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhXOutlined);
export default __webpack_public_path__ + "static/media/fmh-x-outlined.c94df8d52d9288ddd2f6e88ecd344c00.svg";
export { ForwardRef as ReactComponent };